<template>
  <div class="ib-select-menu">
    <q-select
      no-error-icon
      options-dense
      :popup-content-class="`${popupContentClass || ''} gordita-400-12 incredi-select-menu`"
      popup-content-style="{color: '#1B1B1B'}"
      label-color="#99A4A7"
      bottom-slots
      outlined
      :class="{ disabled: $attrs.disable }"
      class="ibc-dropdown"
      v-bind="$attrs"
      :model-value="value"
      :options="options"
      dropdown-icon="icon-down-small"
      :label="label"
      @update:model-value="e => $emit('input', e)"
    >
      <template #error="{ errorMessage }">
        <div
          style="line-height: 15px"
          class="gordita-400-11 ib-color-red"
        >
          <span class="icon-Approval-error"><span class="path1"></span><span class="path2"></span></span>
          <span
            style="margin: 0 4px; line-height: 14px"
            class="message-text"
            >{{ errorMessage }}</span
          >
        </div>
      </template>
    </q-select>
  </div>
</template>

<script>
export default {
  name: 'IncrediSelectMenu',
  props: {
    popupContentClass: {
      type: String,
    },
    value: {
      required: true,
    },
    label: {
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.ib-select-menu {
  .disabled {
    :deep(.q-field__inner) {
      background: $-system-app-background;
      .q-field__control {
        &:before {
          border: 1px solid $-system-app-border;
        }
      }
      .q-field__native {
        color: $-text-text-low-old;
      }
    }
  }
  :deep(.q-field) {
    font-size: 12px !important;
  }
  :deep(.q-select__dropdown-icon) {
    font-size: 10px;
  }
  :deep(.q-field__bottom) {
    padding: 8px 0 !important;
  }
  :deep(.q-field__control) {
    border-radius: 2px;
    padding: 0 16px;
  }
  :deep(.q-field--highlighted .q-field__label) {
    color: $-text-text-primary !important;
  }
  :deep(.q-field__label) {
    font-size: 14px;
  }
  :deep(.q-field--float .q-field__label) {
    transform: translateY(-40%) scale(0.85);
    font-size: 12px;
  }
  :deep(.q-focus-helper) {
    &:not(.disabled) {
      &:hover {
        border-color: $-text--dark;
      }
    }
  }
}
</style>
